module.exports = __webpack_public_path__ + "img/gonggongjigou.c4d0f1f3.png";